module.exports = __webpack_public_path__ + "static/media/sale1.4eef92ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/sale1.png
// module id = 553
// module chunks = 0